var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssistantIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "174px",
    viewBox: "0 0 158 174",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assistant / Dialog Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 158,
    height: 174,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CoDesigner-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CCD21-/-Onboarding-/-C-/-2",
    transform: "translate(-615.000000, -720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assistant-/-Dialog-Copy",
    transform: "translate(615.000000, 720.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-101.000000, -23.000000)",
    id: "Assistant"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-36",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    points: "20.9124821 138.305325 -2.80283733e-13 138.305325 -2.80283733e-13 53.3967013 84.735125 53.3967013 84.735125 138.305325 62.8784464 138.305325"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-38",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "51.3824982 71.4631531 47.4722661 67.9645757 45.1667482 70.2016469 42.6195161 67.9443916 39.8179804 70.1175464 37.2346589 67.9023414 33.3529625 71.4631531 33.3529625 53.3967013 51.3824982 53.3967013"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-40",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "34.6963232 122.487213 34.6963232 133.082184 41.1764482 133.082184 41.1764482 122.487213 45.2696446 122.487213 38.0123411 112.917427 30.7609125 122.483849"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-42",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "10.7385768 116.965264 10.7385768 133.082268 20.5959875 133.082268 20.5959875 116.965264 26.8218089 116.965264 15.7826839 102.408323 4.75195179 116.960218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.535895,242.997983 C140.856734,264.506665 123.438198,285.36441 123.438198,285.36441 L64.1821089,358.328251 C59.8337696,363.682083 60.8123768,371.587523 66.3348768,375.715171 L98.8362161,397.067426 C101.607538,398.8882 105.138412,399.301974 108.159002,397.934502 C110.141395,397.036309 111.93327,395.509887 112.298359,392.915389 C112.42593,392.011309 112.353752,391.102184 112.118752,390.232585",
    id: "Stroke-44",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.0733982,
    y1: 352.274366,
    x2: 80.4009696,
    y2: 338.342291,
    id: "Stroke-46",
    stroke: "#00A1E2",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.122521,314.951526 L129.079289,384.893638 C129.079289,392.543413 122.891236,398.744136 115.257093,398.744136 L103.1932,398.744136",
    id: "Stroke-48",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.760936,400.655066 L183.760936,395.651091 C183.760936,393.155832 183.212043,390.6673 181.992561,388.491623 C178.801596,382.801388 172.932471,381.590342 165.410793,378.01271 L163.197596,376.704949 C163.148918,376.676355 163.100239,376.647761 163.0524,376.618326 C156.268454,372.55207 152.250793,365.080589 152.250793,357.159171 L152.250793,344.385158 C152.250793,336.623531 152.785418,328.871995 153.850471,321.184376 L161.213525,268.068233",
    id: "Stroke-50",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.183477,170.907101 C152.838236,176.269916 149.235319,181.85583 147.072568,184.641459 C142.223175,190.888438 130.100532,202.745756 121.379514,203.069543 C106.50905,203.621242 99.1862821,197.834292 95.2768893,189.791769 C89.3406214,177.579547 96.8555857,164.386715 103.193032,160.035359 C129.741318,141.808275 153.842246,166.10825 156.28205,170.184597 C172.325836,196.998334 152.908121,218.374137 143.964693,223.203183 C118.901104,236.734941 94.0683179,222.543836 97.0074964,203.077112 C99.4909429,189.282121 122.170961,185.248664 132.948229,201.539756 L136.657871,208.137434 L158.248496,252.654309 C164.187282,264.878305 160.654729,277.057727 152.527086,287.943685 L100.085996,351.159447 C98.5962643,353.013861 96.1581393,359.290275 96.1581393,359.290275 C95.1123893,363.375874 95.7980857,367.712091 98.0532464,371.273744 L110.711354,387.456346 C111.359282,388.283895 111.846907,389.232547 112.117996,390.232501",
    id: "Stroke-54",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.057721,147.588413 C169.451114,153.285375 164.986954,162.004066 156.281882,170.184513",
    id: "Stroke-56",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.512839,163.755541 C191.704607,166.249573 191.549965,169.742809 192.048914,174.235249 L192.048928,174.235248 C192.985027,182.663704 200.109077,189.040332 208.589357,189.040332 C208.589357,189.040332 208.589357,189.040332 208.589357,189.040332 C208.589357,189.040332 208.589357,189.040332 208.589357,189.040332 C220.983375,189.040332 231.030712,178.992995 231.030712,166.598976 C231.030712,164.964092 230.852059,163.334103 230.497932,161.738032 C228.227091,151.503228 221.372692,146.532032 209.934732,146.824445",
    id: "Stroke-58",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.378059,135.317573 L229.13798,122.597703 C229.386306,122.049316 229.207778,121.401817 228.713503,121.058179 C228.216148,120.712399 227.542547,120.77245 227.114192,121.200746 C225.276491,123.038268 223.954343,124.566332 223.147747,125.784938 M221.096137,129.043413 C220.608649,129.788314 220.07176,130.648278 219.152321,131.785356",
    id: "Shape",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.200982,111.889215 C138.957259,113.383931 144.326177,114.212497 154.307737,114.374915 L154.307737,114.374884 C165.418455,114.555675 174.278912,123.709252 174.098121,134.81997 C174.044289,138.128259 173.175417,141.372216 171.568464,144.264512 C171.568464,144.264512 171.568464,144.264512 171.568464,144.264512 L156.084062,170.184513",
    id: "Stroke-62",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.200982,111.889215 L138.200982,109.860713 C138.200982,108.728721 138.605518,107.633734 139.342411,106.774228 L139.641196,106.425211 C139.994536,106.013119 140.552661,105.840713 141.076375,105.982843 C143.664732,106.68424 146.404161,106.579115 148.932089,105.681763 C150.461268,105.139315 151.716839,104.016575 152.429393,102.55491 C153.487732,100.382596 153.817571,97.9251816 153.369393,95.5493448 L152.232161,89.5269138 L150.310196,81.2573197 C150.113804,80.4095874 150.071,79.5332611 150.183464,78.6703908 C150.477214,76.4375247 152.046679,74.5831063 154.196929,73.9279682 L158.309429,72.676554 C160.124804,72.1231732 161.068161,69.9760895 160.051786,68.3706126 C159.733696,67.8693741 159.242714,67.4404619 158.499946,67.1890017 L152.493179,64.7980268 C149.339143,63.3464536 148.413411,61.1034954 147.931661,57.6595833 L147.748696,53.8161941 C147.792339,52.388169 147.581679,50.9500519 147.010964,49.6406084 C144.705446,44.3532151 138.251339,40.3391021 132.588679,39.719282 C132.282339,39.6856418 131.974321,39.6612527 131.663786,39.6461146 C131.663786,39.6461146 131.663786,39.6461146 131.663786,39.6461146 C117.844239,38.977945 106.099625,49.6392423 105.431456,63.4587886 C105.274895,66.6968722 105.748314,69.934562 106.82543,72.9922601 C109.595989,80.8571115 110.981268,84.7895372 110.981268,84.7895372 C112.056487,88.454973 112.170229,96.123617 111.322494,107.795469 C111.142438,110.274581 109.181847,112.25224 106.704389,112.453781 L84.735125,114.240977 L84.735125,114.240977",
    id: "Stroke-72",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.964286,89.3718326 C135.964286,89.3718326 145.154464,93.3010042 152.112143,90.3961757",
    id: "Stroke-74",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76227,64.4419456 C135.76227,66.2088954 134.56293,67.6411255 133.08327,67.6411255 C131.603609,67.6411255 130.40427,66.2088954 130.40427,64.4419456",
    id: "Stroke-76",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.701754,63.979141 C144.701754,65.7460908 143.502414,67.1783209 142.022754,67.1783209 C140.543093,67.1783209 139.343754,65.7460908 139.343754,63.979141",
    id: "Stroke-78",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.616499,44.0163726 C122.428072,53.7725454 136.20873,63.6955556 147.011132,49.6413653",
    id: "Stroke-80",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.182189,48.8430841 C120.619639,55.3027238 119.637395,61.1205104 117.235457,66.2964439 C113.63255,74.0603443 111.465272,84.9077824 111.748111,89.3718326",
    id: "Stroke-82",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8078857,138.668302 C74.8078857,138.668302 105.494689,195.103047 69.2879036,195.349747 C62.77085,195.394034 56.1186714,190.215131 53.4044214,186.06898 C51.0594571,182.486302 49.9247429,178.241754 49.9239036,173.956838 L49.9205464,160.159323 C49.70485,152.762691 46.4610107,147.646863 40.4332607,144.489733 C32.0420821,140.093804 21.2387964,139.660687 21.2387964,139.660687 C19.8204036,139.038344 20.1854929,136.928264 21.7306179,136.821457 L24.6093679,136.821457 C30.569975,136.820616 35.7962071,136.666712 42.02035,137.392499 C42.6263143,137.463143 50.0128679,138.051846 50.0128679,138.051846 C51.5588321,138.051846 53.0552786,137.500147 54.2336357,136.495988 L64.409975,127.826917 C66.3344571,126.788277 68.8011179,126.955637 67.1812964,131.133746 L62.2958143,140.142582 C60.9193857,142.682415 59.9382607,147.11703 60.1338143,150.000833 C60.438475,154.491796 61.6352964,159.733775 62.8816357,164.199507",
    id: "Stroke-84",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7476857,163.755541 C64.3633107,168.741014 64.3591143,174.152035 62.4967393,179.050043 C60.74515,183.656223 58.4933464,189.040332 46.6711679,189.040332 C36.2631857,189.040332 26.2815607,184.271838 24.1976143,176.119144 C22.0440071,167.693964 21.7284357,146.824445 43.5825964,146.824445",
    id: "Stroke-86",
    stroke: "#FF8042",
    strokeWidth: 1.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2028036,147.588413 C85.8094107,153.285375 87.7540357,159.745128 96.4591071,167.926417",
    id: "Stroke-88",
    stroke: "#FF8042",
    strokeWidth: 1.68
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-90",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    points: "25.8810536 53.3701255 79.142125 53.3701255 79.142125 2.39027766e-14 25.8810536 2.39027766e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-92",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    points: "45.7553393 4.87950628 59.2695179 4.87950628 59.2695179 4.8179034e-14 45.7553393 4.8179034e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-93",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    points: "45.7553393 53.3970377 59.2695179 53.3970377 59.2695179 41.214251 45.7553393 41.214251"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.909538,
    y1: 400.892482,
    x2: 183.760936,
    y2: 400.892482,
    id: "Stroke-1",
    stroke: "#00A1E2",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.441739,
    y1: 364.509968,
    x2: 129.285418,
    y2: 364.509968,
    id: "Stroke-52",
    stroke: "#00A1E2",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(193.035714, 111.012552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5482143,17.492887 L18.5482143,20.1841004 L12.0017857,20.1841004 L12.0017857,17.492887 L18.5482143,17.492887 Z M17.4571429,1.09330544 L17.4571429,3.78451883 L13.0928571,3.78451883 L13.0928571,1.09330544 L17.4571429,1.09330544 Z",
    id: "Combined-Shape",
    fill: "#FF8042",
    transform: "translate(15.275000, 10.638703) scale(-1, 1) translate(-15.275000, -10.638703) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.275,4.37322176 C23.3156366,4.37322176 29.9052358,10.1539037 30.5054442,17.4924533 L0.0445557829,17.4924533 C0.644764156,10.1539037 7.23436343,4.37322176 15.275,4.37322176 Z M20.7303571,1.09330544 L9.81964286,1.09330544",
    id: "Combined-Shape",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(15.275000, 8.746227) scale(-1, 1) translate(-15.275000, -8.746227) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2613048,25.1460251 C17.1322573,25.1460251 10.2191322,25.1460251 6.15460842,25.1460251 M2.51785714,24.0898233 C2.51785714,23.2071709 2.51785714,22.6950705 2.51785714,22.5535224 C2.51785714,22.4007638 2.51785714,22.1716259 2.51785714,21.8661088 C2.51785714,21.2622929 3.00634646,20.7728033 3.60892857,20.7728033 L30.3423446,20.7728033",
    id: "Shape",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(16.430101, 22.959414) scale(-1, 1) translate(-16.430101, -22.959414) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.053723,111.889215 C113.943167,119.661866 123.397162,122.809827 131.169813,118.920384 C134.211838,117.398151 136.67875,114.931239 138.200982,111.889215 L138.200982,111.889215 L138.200982,111.889215",
    id: "Path-3",
    stroke: "#FF8042",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.588222,142.152768 C172.588222,142.152768 152.983825,199.106395 185.97195,195.349629 C194.358093,194.39509 199.142021,190.215299 201.856271,186.069148 C204.201236,182.485629 205.33595,178.241922 205.336789,173.957006 L205.340146,160.159491 C205.555843,152.762859 208.799682,145.965023 214.827432,142.807893 C223.218611,138.411964 234.021057,137.137843 234.021057,137.137843 C235.43945,136.5155 235.074361,134.40542 233.530075,134.298613 L230.650486,134.298613 C227.075299,134.298133 221.737258,135.449862 214.636364,137.753798 C212.105195,138.575054 209.402113,138.713745 206.800183,138.15586 L204.590929,137.68217 C201.587215,137.038139 198.850931,135.494445 196.746374,133.256608 L190.595456,126.71616 C189.754233,125.821624 188.347122,125.778436 187.452604,126.619679 C186.792785,127.240202 186.57534,128.198953 186.9029,129.043413 C186.9029,129.043413 186.9029,129.043413 186.9029,129.043413 L192.964039,140.142751 C194.351379,142.701085 195.32495,147.167659 195.121843,150.072487 C194.809629,154.548311 193.618682,159.757491 192.379057,164.199675",
    id: "Stroke-32",
    stroke: "#FF8042",
    strokeWidth: 1.68
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIllustration);
export default __webpack_public_path__ + "static/media/Assistant_Illustration.57c7f490147d09db301e9b0443f5a4b6.svg";
export { ForwardRef as ReactComponent };